import * as yup from 'yup';
import { userGroupFormFields } from '../../fields/formFields';

export const userGroupFormSchema = yup.object({
  [userGroupFormFields.nameEn]: yup
    .string()
    .max(150, 'Name En must be at most 150 characters')
    .required('Name En is required')
    .trim(),
  [userGroupFormFields.nameAr]: yup
    .string()
    .max(150, 'Name Ar must be at most 150 characters')
    .required('Name Ar is required')
    .trim(),
  [userGroupFormFields.descriptionEn]: yup
    .string()
    .max(150, 'Description En must be at most 150 characters')
    .required('Description En is required')
    .trim(),
  [userGroupFormFields.descriptionAr]: yup
    .string()
    .max(150, 'Description Ar must be at most 150 characters')
    .required('Description Ar is required')
    .trim(),
});
